export default __webpack_public_path__ + "static/media/value4.cfae53ac.svg";